var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from 'hx-util';
import { CustomBestBuyLogo } from './custom-best-buy-logo';
export function LogoAndHeading(_a) {
    var headingText = _a.headingText, className = _a.className, image = _a.image;
    return (_jsxs("div", __assign({ className: cn('flex flex-col items-center', className) }, { children: [_jsx(CustomBestBuyLogo, { imageHeight: image.height, imageWidth: image.width, className: 'text-black' }), !!headingText && _jsx("div", __assign({ className: "text-center" }, { children: headingText }))] })));
}
